module.exports = false;



//////////////////
// WEBPACK FOOTER
// D:/发行部门文件/后台管理系统文件/~/core-js/modules/_library.js
// module id = 35
// module chunks = 0